import { CustomDatePicker } from './../../../../../components/CustomDatePicker';
import CustomTimePicker from './../../../../../components/CustomTimePicker';
import { CustomSelectAndChildren } from './../../../../../components/CustomSelectAndChildren';
import { CustomTextField } from './../../../../../components/CustomTextField';
import { CustomAddMediumChip } from './../../../../../components/CustomAddMediumChip';
import DividerWithText from './../../../../../components/DividerWithText';
import { MenuItem } from '@mui/material';
import { DishCategoryEnum } from '../Model/Model';
import { militaryHourToTimeString, timeStringToDate } from '../../../../../utils/TimeConversion';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Availability = ({
    t,
    disabled,
    emptyFields,
    handleChange,
    item,
    allCourseType,
    departments,
    selectedDepartment,
    setSelectedDepartment,
    isServingDateValid,
    setDepartment,
    notSelected
}) => {

    return (
        <div>
            <div className='row'>
                <div className='col-sm-12 col-md-6'>
                    <CustomDatePicker
                        id='dp_a_release_date'
                        name='releaseDate'
                        trans='release_date'
                        value={item.releaseDate}
                        openTo='day'
                        disablePast={true}
                        required={true}
                        disabled={disabled}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'releaseDate' } });
                        }}
                        emptyFields={emptyFields}
                    />
                </div>

                <div className='col-sm-12 col-md-6'>
                    <CustomTimePicker
                        title={t('release_hour')}
                        name='releaseHour'
                        inputFormat="HH:mm"
                        disabled={disabled}
                        emptyFields={emptyFields}
                        handleChange={(value) => handleChange({ target: { name: 'releaseHour', value: value } })}
                        value={
                            item?.releaseHour
                                ? typeof item?.releaseHour === 'number'
                                    ? timeStringToDate(militaryHourToTimeString(item.releaseHour))
                                    : timeStringToDate(item.releaseHour)
                                : null
                        }
                        required={true}
                        id='tp_a_release_hour'
                        actions={['accept', 'cancel']}
                        formatValue={true}
                        views={['hours', 'minutes']}
                    />
                </div>

                <div className='col-sm-12 col-md-6'>
                    <CustomDatePicker
                        id='dp_a_cafeteria_serving_date'
                        name='cafeteriaServingDate'
                        trans='cafeteria_serving_date'
                        value={item.cafeteriaServingDate}
                        minDate={item.releaseDate}
                        disablePast={true}
                        openTo='day'
                        required={true}
                        disabled={disabled}
                        isValidText={t('cafeteria_date_must_be_greater')}
                        isValid={ isServingDateValid}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'cafeteriaServingDate' } });
                        }}
                        emptyFields={emptyFields}
                    />
                </div>

                <div className='col-sm-12 col-md-6'>
                    <CustomSelectAndChildren
                        id={'slt_a_course_type'}
                        name={'courseType'}
                        trans={'course_type'}
                        disabled={disabled}
                        onChange={handleChange}
                        emptyFields={emptyFields}
                        showNoSelectionOption={false}
                        required={true}
                        value={item?.courseType}
                    >
                        {allCourseType?.map((meal) => (
                            <MenuItem key={meal.id} value={meal.id}>
                                {t(DishCategoryEnum[meal.id]?.name || '')}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            </div>
            <div className='col-12 mt-2 mb-2'>
                <DividerWithText title={t('department_release_delay_priority')} />
                <div className='mt-3'>
                    <CustomAddMediumChip
                        autocompleteId='autocomplete_department'
                        buttonId='btn_add_department'
                        textFielId='department_unit'
                        disabled={disabled}
                        required={false}
                        label={'Department'}
                        typeUnit={'time'}
                        transUnit="available_after"
                        unitLength={3}
                        data={departments}
                        selectedList={selectedDepartment}
                        setSelectedList={setSelectedDepartment}
                        onSelectItem={(item) => setDepartment((prev) => ({ ...prev, item }))}
                        onChangeUnit={(unit) => setDepartment((prev) => ({ ...prev, unit }))}
                        emptyFields={notSelected && emptyFields}
                    />
                </div>
            </div>
        </div>
    );
};

export default Availability;
